var $ = require('jquery');

module.exports = function() {

    // Permissions
    var togglePermissions = function() {
        var guest = $('#guest').prop('checked');
        var registration = $('#registration').prop('checked') || $('#defaultForRegistration').prop('checked');

        if (guest && registration) {
            $('.guest-denied input[value="inherit"], .registration-denied input[value="inherit"]').prop('checked', true);
            $('.guest-denied input, .registration-denied input').prop('disabled', true);
        } else if (guest && !registration) {
            $('.registration-denied input').prop('disabled', false);
            $('.guest-denied input[value="inherit"]').prop('checked', true);
            $('.guest-denied input').prop('disabled', true);
        } else if (!guest && registration) {
            $('.guest-denied input').prop('disabled', false);
            $('.registration-denied input[value="inherit"]').prop('checked', true);
            $('.registration-denied input').prop('disabled', true);
        } else {
            $('.guest-denied input, .registration-denied input').prop('disabled', false);
        }

        // If it's denied, it will be disabled, regardless of guest/registration logic
        $('.denied input').prop('disabled', true);

        // Toggle guest-disable inputs
        if (guest) {
            $('.guest-disable').prop('disabled', true);
            $('.guest-disable').prop('checked', false);
        } else {
            $('.guest-disable').prop('disabled', false);
        }
    };

    $('#guest, #registration, #defaultForRegistration').on('change', togglePermissions);
    togglePermissions();

    // Register URL
    var toggleRegisterUrl = function() {
        var enabled = $('#registration').prop('checked');
        $('.registration-only').toggleClass('hidden', !enabled);
    };

    $('#registration').on('change', toggleRegisterUrl);
    toggleRegisterUrl();

    var toggleRegistrationAction = function() {
        var action = $('[name="registrationAction"]:checked').val();

        $('.action-content-block, .action-score-set').hide();
        $('.action-'+action).show();
    };

    $('[name="registrationAction"]').on('change', toggleRegistrationAction);
    toggleRegistrationAction();
};
